'use strict'

/**
 * Типы actions, доступные для вызова в хранилище
 */

export const GUI = {
  tryInit: {
    set: 'gui/tryInit/set'
  }
}

export const APP = {
  statusRequest: {
    set: 'app/statusRequest/set'
  },
  receiptInfo: {
    set: 'app/receiptInfo/set'
  }
}
